<div class="bg-white my-2">
    <div class="container">
      <div class="faq-section">
        <div class="inner-container">
          <div class="pattern-layer wow slideInRight" 
               data-wow-delay="500ms" data-wow-duration="1500ms"
               style="background-image: url(assets/images/bg/pattern-9.png)">
          </div>
          <div class="container">
            <div class="row clearfix">
              <div class="col-lg-12 col-md-12 col-sm-12 inner-column mt-5">
                <div class="inner-box">
                  <div class="sec-title mb-30">
                    <h2 class="pb-4">{{ "Footer.About" | translate }}</h2>
                    <h4 class="p-1" style="text-align: justify;">
                      {{ 'Footer.Description' | translate }}
                    </h4>
                    <h4 class="pb-4 p-1" style="text-align: justify;">
                      {{ 'Footer.Details' | translate }}
                    </h4>
                  </div>  
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </div>
  